const AddToCartIcon = () => {
  return (
    <svg
      width='35'
      height='35'
      viewBox='0 0 35 35'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_115_6163)'>
        <path
          d='M8.74935 33.5417C9.55476 33.5417 10.2077 32.8887 10.2077 32.0833C10.2077 31.2779 9.55476 30.625 8.74935 30.625C7.94393 30.625 7.29102 31.2779 7.29102 32.0833C7.29102 32.8887 7.94393 33.5417 8.74935 33.5417Z'
          fill='#DC2626'
        />
        <path
          d='M29.1663 33.5417C29.9718 33.5417 30.6247 32.8887 30.6247 32.0833C30.6247 31.2779 29.9718 30.625 29.1663 30.625C28.3609 30.625 27.708 31.2779 27.708 32.0833C27.708 32.8887 28.3609 33.5417 29.1663 33.5417Z'
          fill='#DC2626'
        />
        <path
          d='M8.74935 33.5417C9.55476 33.5417 10.2077 32.8887 10.2077 32.0833C10.2077 31.2779 9.55476 30.625 8.74935 30.625C7.94393 30.625 7.29102 31.2779 7.29102 32.0833C7.29102 32.8887 7.94393 33.5417 8.74935 33.5417Z'
          stroke='#DC2626'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='square'
        />
        <path
          d='M29.1663 33.5417C29.9718 33.5417 30.6247 32.8887 30.6247 32.0833C30.6247 31.2779 29.9718 30.625 29.1663 30.625C28.3609 30.625 27.708 31.2779 27.708 32.0833C27.708 32.8887 28.3609 33.5417 29.1663 33.5417Z'
          stroke='#DC2626'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='square'
        />
        <path
          d='M6.99967 10.2083H32.083L29.1663 24.7916H8.74967L5.83301 2.91663H1.45801'
          stroke='#DC2626'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='square'
        />
        <path d='M32 10.5H7.5L9 25H29L32 10.5Z' fill='#DC2626' />
      </g>
      <path
        d='M20.1328 16.2617H24.668V18.8281H20.1328V23.3398H17.5664V18.8281H13.0312V16.2617H17.5664V11.6914H20.1328V16.2617Z'
        fill='white'
      />
      <defs>
        <clipPath id='clip0_115_6163'>
          <rect width='35' height='35' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AddToCartIcon
